import React from "react";
import "../../css/Wireframe.css";
import Banner from "../../components/Banner";
import Select from "react-select";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Sidebar } from "./../../components/Sidebar";

const API = localStorage.getItem("assethost");
const emailRegex =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
const emailError = "Please enter a valid email address (e.g. name@example.com)";
// eslint-disable-next-line no-useless-escape
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9])) {
    last = id + placeholder1.substring(id.length);
  } else if (id.length >= 10) {
    last = id + placeholder2.substring(id.length);
  } else {
    last = id + ogPlaceholder.substring(id.length);
  }
  return start + last;
}
function formatNationalId(e, state, field, isZimbabwean = true) {
  let currentValue = String(state[field] || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const newState = { ...state, [field]: e };
    return { newPlaceholder, error, newState };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, newState: state };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      newValue = e;
      newPlaceholder = /[A-Z]/.test(e[9])
        ? e + placeholder1.substring(e.length)
        : e + placeholder2.substring(e.length);
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  let newState = { ...state, [field]: newValue };
  return { newPlaceholder, error, newState };
}

export default class Insurance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      registrationNumber: "",
      address1: "",
      address2: "",
      townCityId: 0,
      contactFirstname: "",
      contactSurname: "",
      contactRole: "",
      contactEmail: "",
      contactCellphone: "",
      contactNationality: "",
      contactIdentification: "",
      contactPassportNumber: "",
      contactIdentificationDocument: null,
      contactPassportDocument: null,
      certificateOfIncorporation: null,
      cr14: null,
      username: "",
      password: "",
      passwordConfirm: "",
      errors: {},
      msg: "",
      toastColor: "",
      loading: false,
      companyLookupData: {},
      idPlaceholder: ogPlaceholder,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleId = this.handleId.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.getLookupData = this.getLookupData.bind(this);
  }
  componentDidMount() {
    this.getLookupData();
  }

  isZimbabweanContact() {
    return this.state.contactNationality === "ZW";
  }
  getLookupData() {
    this.setState({ loading: true, msg: "", toastColor: "" });

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }

    axios
      .get(API + "/register/getcompanydropdownlists", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        this.setState({ companyLookupData: res.data || {} }, this.validate);
      })
      .catch((err) => {
        this.setState({
          msg:
            err?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
          loading: false,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
  handleChange(e) {
    const { name, value, type, files } = e.target;
    const newValue = type === "file" ? files && files[0] : value;
    this.setState({ [name]: newValue }, this.validate);
  }
  handleSelect(name, option) {
    this.setState(
      {
        [name]: option
          ? option.value
          : typeof option === "string"
          ? option
          : "",
      },
      this.validate
    );
  }
  handleId(val, field = "contactIdentification") {
    const { newPlaceholder, error, newState } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabweanContact()
    );
    this.setState(
      {
        [field]: newState[field],
        ...(field === "contactIdentification"
          ? { idPlaceholder: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }
  validate() {
    let s = this.state,
      e = {},
      valid = true;
    if (!s.name || !s.name.trim()) {
      e.name = "Name is required";
      valid = false;
    }
    if (!s.registrationNumber || !s.registrationNumber.trim()) {
      e.registrationNumber = "Registration No is required";
      valid = false;
    }
    if (!s.address1 || !s.address1.trim()) {
      e.address1 = "Address 1 is required";
      valid = false;
    }
    if (!s.townCityId || s.townCityId === 0) {
      e.townCityId = "Town/City is required";
      valid = false;
    }
    if (!s.contactFirstname || !s.contactFirstname.trim()) {
      e.contactFirstname = "Contact Firstname is required";
      valid = false;
    }
    if (!s.contactSurname || !s.contactSurname.trim()) {
      e.contactSurname = "Contact Surname is required";
      valid = false;
    }
    if (!s.contactRole || !s.contactRole.trim()) {
      e.contactRole = "Contact Role is required";
      valid = false;
    }
    if (!s.contactEmail || !s.contactEmail.trim()) {
      e.contactEmail = "Contact Email is required";
      valid = false;
    } else if (!emailRegex.test(s.contactEmail)) {
      e.contactEmail = emailError;
      valid = false;
    }
    if (!s.contactCellphone || !s.contactCellphone.trim()) {
      e.contactCellphone = "Contact Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(s.contactCellphone)) {
      e.contactCellphone = phoneError;
      valid = false;
    }
    if (!s.contactNationality || !s.contactNationality.trim()) {
      e.contactNationality = "Contact Nationality is required";
      valid = false;
    }
    if (this.isZimbabweanContact()) {
      if (!s.contactIdentification || !s.contactIdentification.trim()) {
        e.contactIdentification = "Contact National ID is required";
        valid = false;
      } else if (!nationalIdRegex.test(s.contactIdentification)) {
        e.contactIdentification = dynamicNationalIdError(
          s.contactIdentification
        );
        valid = false;
      }
    } else {
      if (!s.contactPassportNumber || !s.contactPassportNumber.trim()) {
        e.contactPassportNumber = "Contact Passport Number is required";
        valid = false;
      }
    }
    if (!s.username || !s.username.trim()) {
      e.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      e.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      e.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(s.password)) {
      e.password = passwordError;
      valid = false;
    }
    if (!s.passwordConfirm || !s.passwordConfirm.trim()) {
      e.passwordConfirm = "Password Confirm is required";
      valid = false;
    } else if (s.password !== s.passwordConfirm) {
      e.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(s.passwordConfirm)) {
      e.passwordConfirm = passwordError;
      valid = false;
    }
    this.setState({ errors: e });
    return valid;
  }
  handleRegister(e) {
    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
        loading: false,
      });
      return;
    }
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }
    let data = new FormData();
    data.append("user.username", this.state.username);
    data.append("user.password", this.state.password);
    data.append("user.userType", "COMPANY");
    data.append(
      "user.fullName",
      [this.state.contactFirstname, this.state.contactSurname].join(" ")
    );
    data.append("user.mobileVerified", "NO");
    data.append("user.activeStatus", "YES");
    data.append("user.emailVerified", "NO");
    data.append("user.isPaidService", "NO");
    data.append("profile.companyName", this.state.name);
    data.append("profile.registrationNumber", this.state.registrationNumber);
    data.append("profile.townCityId", String(this.state.townCityId));
    data.append(
      "profile.physicalAddress",
      [this.state.address1, this.state.address2].filter(Boolean).join(", ")
    );
    data.append("profile.primaryContactFirstName", this.state.contactFirstname);
    data.append("profile.primaryContactSurname", this.state.contactSurname);
    data.append("profile.primaryContactRole", this.state.contactRole);
    data.append(
      "profile.primaryContactIdNumber",
      this.state.contactIdentification
    );
    data.append(
      "profile.primaryPassportNumber",
      this.state.contactPassportNumber
    );
    data.append("profile.primaryContactNumber", this.state.contactCellphone);
    data.append("profile.primaryContactEmail", this.state.contactEmail);
    data.append("profile.companyType", "INSURANCE");
    if (this.state.contactIdentificationDocument)
      data.append(
        "primaryContactIdentityDocument",
        this.state.contactIdentificationDocument
      );
    if (this.state.contactPassportDocument)
      data.append(
        "primaryContactPassportDocument",
        this.state.contactPassportDocument
      );
    if (this.state.certificateOfIncorporation)
      data.append(
        "certificateIncorpFile",
        this.state.certificateOfIncorporation
      );
    if (this.state.cr14) data.append("cr14File", this.state.cr14);
    var self = this;
    axios
      .post(API + "/insurance/save", data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1700);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
            loading: false,
          });
          if (
            response.data.message &&
            response.data.message.includes("username already exist")
          ) {
            self.setState({
              errors: { ...self.state.errors, username: response.data.message },
            });
          }
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="d-flex flex-column min-vh-100">
        <Sidebar />
        <div className="d-flex flex-column flex-grow-1">
          <Banner title="Register as Insurance" align="center" />
          {divMsg}
          <form
            className="d-flex flex-column align-items-center w-100 mt-2 overflow-auto was-validated"
            autoComplete="off"
            onSubmit={this.handleRegister}
          >
            <div className="w-100" style={{ maxWidth: "1200px" }}>
              <div className="row g-4">
                {/* Company Information Section */}
                <div className="col-12">
                  <h5 className="fw-bold text-primary mb-3">
                    <i className="bi bi-building me-2"></i>Company Information
                  </h5>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Name</span>
                      <input
                        type="text"
                        name="name"
                        className={`form-control ${s.errors.name ? "z-0" : "z-0"}`}
                        value={s.name}
                        onChange={this.handleChange}
                        required
                        autoFocus
                      />
                    </div>
                    {s.errors.name && (
                      <div className="text-danger small">{s.errors.name}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Registration No</span>
                      <input
                        type="text"
                        name="registrationNumber"
                        className={`form-control ${s.errors.registrationNumber ? "z-0" : "z-0"}`}
                        value={s.registrationNumber}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.registrationNumber && (
                      <div className="text-danger small">{s.errors.registrationNumber}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Address 1</span>
                      <input
                        type="text"
                        name="address1"
                        className={`form-control ${s.errors.address1 ? "z-0" : "z-0"}`}
                        value={s.address1}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.address1 && (
                      <div className="text-danger small">{s.errors.address1}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Address 2</span>
                      <input
                        type="text"
                        name="address2"
                        className={`form-control ${s.errors.address2 ? "z-0" : "z-0"}`}
                        value={s.address2}
                        onChange={this.handleChange}
                      />
                    </div>
                    {s.errors.address2 && (
                      <div className="text-danger small">{s.errors.address2}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Town/City</span>
                      <Select
                        name="townCityId"
                        value={(s.companyLookupData.townCitys || []).filter(
                          ({ value }) => value === s.townCityId
                        )}
                        onChange={(e) => this.handleSelect("townCityId", e)}
                        className={`form-control ${s.errors.townCityId ? "" : ""}`}
                        required
                        options={s.companyLookupData.townCitys || []}
                      />
                    </div>
                    {s.errors.townCityId && (
                      <div className="text-danger small">{s.errors.townCityId}</div>
                    )}
                  </div>
                </div>

                {/* Contact Information Section */}
                <div className="col-12 mt-4">
                  <h5 className="fw-bold text-primary mb-3">
                    <i className="bi bi-person-badge me-2"></i>Contact Information
                  </h5>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Contact Firstname</span>
                      <input
                        type="text"
                        name="contactFirstname"
                        className={`form-control ${s.errors.contactFirstname ? "z-0" : "z-0"}`}
                        value={s.contactFirstname}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.contactFirstname && (
                      <div className="text-danger small">{s.errors.contactFirstname}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Contact Surname</span>
                      <input
                        type="text"
                        name="contactSurname"
                        className={`form-control ${s.errors.contactSurname ? "z-0" : "z-0"}`}
                        value={s.contactSurname}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.contactSurname && (
                      <div className="text-danger small">{s.errors.contactSurname}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Contact Role</span>
                      <input
                        type="text"
                        name="contactRole"
                        className={`form-control ${s.errors.contactRole ? "z-0" : "z-0"}`}
                        value={s.contactRole}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.contactRole && (
                      <div className="text-danger small">{s.errors.contactRole}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Contact Email</span>
                      <input
                        type="email"
                        name="contactEmail"
                        className={`form-control ${s.errors.contactEmail ? "z-0" : "z-0"}`}
                        value={s.contactEmail}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.contactEmail && (
                      <div className="text-danger small">{s.errors.contactEmail}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Contact Cellphone</span>
                      <input
                        type="text"
                        name="contactCellphone"
                        className={`form-control ${s.errors.contactCellphone ? "z-0" : "z-0"}`}
                        value={s.contactCellphone}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.contactCellphone && (
                      <div className="text-danger small">{s.errors.contactCellphone}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Contact Nationality</span>
                      <Select
                        name="contactNationality"
                        value={(s.companyLookupData.countrys || []).find(
                          ({ value }) => value === s.contactNationality
                        )}
                        onChange={(option) => {
                          this.handleId("", "contactIdentification");
                          this.handleId("", "contactPassportNumber");
                          this.setState({ idPlaceholder: ogPlaceholder });
                          this.handleSelect("contactNationality", option);
                        }}
                        className={`form-control ${s.errors.contactNationality ? "" : ""}`}
                        required
                        options={s.companyLookupData.countrys || []}
                      />
                    </div>
                    {s.errors.contactNationality && (
                      <div className="text-danger small">{s.errors.contactNationality}</div>
                    )}
                  </div>
                </div>
                
                {!!s.contactNationality && this.isZimbabweanContact() ? (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Contact National ID</span>
                        <input
                          type="text"
                          name="contactIdentification"
                          className={`form-control ${s.errors.contactIdentification ? "z-0" : "z-0"}`}
                          value={s.contactIdentification}
                          placeholder={s.idPlaceholder}
                          onChange={(e) =>
                            this.handleId(e.target.value, "contactIdentification")
                          }
                          required
                        />
                      </div>
                      {s.errors.contactIdentification && (
                        <div className="text-danger small">{s.errors.contactIdentification}</div>
                      )}
                    </div>
                  </div>
                ) : !!s.contactNationality ? (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Contact Passport Number</span>
                        <input
                          type="text"
                          name="contactPassportNumber"
                          className={`form-control ${s.errors.contactPassportNumber ? "z-0" : "z-0"}`}
                          value={s.contactPassportNumber}
                          onChange={(e) =>
                            this.handleId(e.target.value, "contactPassportNumber")
                          }
                          required
                        />
                      </div>
                      {s.errors.contactPassportNumber && (
                        <div className="text-danger small">{s.errors.contactPassportNumber}</div>
                      )}
                    </div>
                  </div>
                ) : null}
                
                {!!s.contactNationality && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label
                        htmlFor={
                          this.isZimbabweanContact()
                            ? "contactIdentificationDocument"
                            : "contactPassportDocument"
                        }
                        className="form-label"
                      >
                        <i className="bi bi-file-earmark me-2"></i>
                        {this.isZimbabweanContact()
                          ? "Contact National ID Document"
                          : "Contact Passport Document"}
                      </label>
                      <div className="input-group">
                        <span className="input-group-text"></span>
                        <input
                          name={
                            this.isZimbabweanContact()
                              ? "contactIdentificationDocument"
                              : "contactPassportDocument"
                          }
                          className="form-control"
                          type="file"
                          id={
                            this.isZimbabweanContact()
                              ? "contactIdentificationDocument"
                              : "contactPassportDocument"
                          }
                          onChange={this.handleChange}
                          accept=".pdf,image/*"
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Document Uploads Section */}
                <div className="col-12 mt-4">
                  <h5 className="fw-bold text-primary mb-3">
                    <i className="bi bi-file-earmark-text me-2"></i>Company Documents
                  </h5>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Certificate of Incorporation</span>
                      <input
                        name="certificateOfIncorporation"
                        className="form-control"
                        type="file"
                        id="certOfIncorp"
                        onChange={this.handleChange}
                        accept=".pdf,image/*"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">CR14</span>
                      <input
                        name="cr14"
                        className="form-control"
                        type="file"
                        id="cr14"
                        onChange={this.handleChange}
                        accept=".pdf,image/*"
                      />
                    </div>
                  </div>
                </div>

                {/* Account Information Section */}
                <div className="col-12 mt-4">
                  <h5 className="fw-bold text-primary mb-3">
                    <i className="bi bi-shield-lock me-2"></i>Account Information
                  </h5>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Username</span>
                      <input
                        type="text"
                        name="username"
                        className={`form-control ${s.errors.username ? "z-0" : "z-0"}`}
                        value={s.username}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.username && (
                      <div className="text-danger small">{s.errors.username}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Password</span>
                      <input
                        type="password"
                        name="password"
                        className={`form-control ${s.errors.password ? "z-0" : "z-0"}`}
                        value={s.password}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.password && (
                      <div className="text-danger small">{s.errors.password}</div>
                    )}
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Password Confirm</span>
                      <input
                        type="password"
                        name="passwordConfirm"
                        className={`form-control ${s.errors.passwordConfirm ? "z-0" : "z-0"}`}
                        value={s.passwordConfirm}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.passwordConfirm && (
                      <div className="text-danger small">{s.errors.passwordConfirm}</div>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="d-flex justify-content-center gap-4 mt-4 mb-4">
                {s.valid && (
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-check-circle me-2"></i>Register
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => window.history.back()}
                >
                  <i className="bi bi-x-circle me-2"></i>Cancel
                </button>
              </div>
            </div>
          </form>
          
        </div>
      </div>
    );
  }
}
